module.exports = __webpack_public_path__ + "static/img/profile.3cb8813.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/profile.png
// module id = 65UA
// module chunks = 1